import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    withStyles,
    Card,
    CardHeader,
    CardContent,
    Typography,
    IconButton,
    CircularProgress,
    Tooltip,
    MenuItem,
    Menu,
    Grid
} from '@material-ui/core';
import {
    PersonAdd as PersonAddIcon,
    Add as AddIcon,
    Close as CloseIcon,
    Check as CheckIcon,
    Star as StarIcon,
    StarBorder as StarBorderIcon,
    MoreVert as MoreVertIcon
} from '@material-ui/icons';
import { FHETextField } from 'data/components';
import { Toastr } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';

class UserCard extends PureComponent {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        user: PropTypes.object,
        userId: PropTypes.number,
        addSpecialUserFunc: PropTypes.func,
        addUserFunc: PropTypes.func,
        deleteUserFunc: PropTypes.func,
        editUserFunc: PropTypes.func,
        deleteUserAndSwitchMasterFunc: PropTypes.func,
        switchMasterFunc: PropTypes.func,
        resetPasswordFunc: PropTypes.func,
        resendWelcomeUserEmailFunc: PropTypes.func,
        actionDisabled: PropTypes.bool,
        deleteUserRight: PropTypes.bool,
        resendWelcomeUserEmailRight: PropTypes.bool,
        resetUserPasswordRight: PropTypes.bool,
        editUserRight: PropTypes.bool,
        switchMasterRight: PropTypes.bool,
        deleteMasterRight: PropTypes.bool,
        modeAdd: PropTypes.bool,
        setIsMaster: PropTypes.bool,
        toggleActions: PropTypes.func,
        otherUsers: PropTypes.array
    };
    static defaultProps = {
        user: null,
        userId: null,
        addSpecialUserFunc: null,
        addUserFunc: null,
        deleteUserFunc: null,
        editUserFunc: null,
        deleteUserAndSwitchMasterFunc: null,
        switchMasterFunc: null,
        resetPasswordFunc: null,
        resendWelcomeUserEmailFunc: null,
        actionDisabled: false,
        editUserRight: false,
        deleteUserRight: false,
        resetUserPasswordRight: false,
        resendWelcomeUserEmailRight: false,
        switchMasterRight: false,
        deleteMasterRight: false,
        setIsMaster: false,
        modeAdd: false,
        toggleActions: null,
        otherUsers: []
    };

    constructor(props) {
        super(props);
        const { user } = props;

        this.state = {
            mouseOver: false,
            anchorEl: null,
            masterLoading: false,
            loading: false,
            editing: false,
            openedMenu: false,
            specialUser: false,
            userForm: {
                password: user && user.get('password', ''),
                lastname: user && user.get('lastname', ''),
                firstname: user && user.get('firstname', ''),
                email: user && user.get('email', ''),
                telFixe: user && user.get('telFixe', null),
                telPort: user && user.get('telPort', null)
            },
            textInput_error: {}
        };
    }

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    /* STATE */
    resetInputs = () => {
        const { user } = this.props;
        this.setState({
            editing: false,
            specialUser: false,
            userForm: {
                password: user && user.get('password', ''),
                lastname: user && user.get('lastname', ''),
                firstname: user && user.get('firstname', ''),
                email: user && user.get('email', ''),
                telFixe: user && user.get('telFixe', null),
                telPort: user && user.get('telPort', null)
            },
            textInput_error: {}
        });
    };
    openMenuState = e => {
        this.setState({ openedMenu: true, anchorEl: e.currentTarget });
    };
    closeMenuState = () => {
        this.setState({ openedMenu: false });
    };
    toggleEditingState = () => {
        const { editing } = this.state;
        this.setState({ editing: !editing, openedMenu: false });
    };
    toggleEditingStateSpecialUser = () => {
        const { editing, specialUser } = this.state;
        this.setState({ editing: !editing, specialUser: !specialUser });
    };
    toggleLoading = () => {
        const { loading } = this.state;
        this.setState({ loading: !loading });
    };
    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };
    handleChange = event => {
        const { userForm, textInput_error } = this.state;
        let targetValue = event.target.value;
        const fieldLengthRules = {
            password: 255,
            lastname: 255,
            firstname: 255,
            email: 200,
            telFixe: 20,
            telPort: 20
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = userForm[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            userForm: { ...userForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleFormError = fields => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });
        this.setState({
            textInput_error: res
        });
    };

    /* ACTIONS */
    saveUser = () => {
        const { editUserFunc, addUserFunc, modeAdd, userId, setIsMaster } = this.props;
        const { userForm } = this.state;

        if (this.validateForm(userForm)) {
            this.toggleLoading();
            if (modeAdd) {
                userForm.isMaster = setIsMaster;
                addUserFunc(userForm)
                    .then(() => {
                        this.resetInputs();
                    })
                    .catch(error => {
                        if (error.validation && error.validation.errors) {
                            return this.handleFormError(error.validation.errors);
                        }
                    })
                    .finally(() => {
                        this.toggleLoading();
                    });
            } else {
                editUserFunc(userId, userForm)
                    .then(() => {
                        this.toggleEditingState();
                    })
                    .catch(error => {
                        if (error.validation && error.validation.errors) {
                            return this.handleFormError(error.validation.errors);
                        }
                    })
                    .finally(() => {
                        this.toggleLoading();
                    });
            }
        }
    };
    saveSpecialUser = () => {
        const { addSpecialUserFunc } = this.props;
        const { userForm } = this.state;

        if (this.validateForm(userForm)) {
            this.toggleLoading();
            addSpecialUserFunc(userForm)
                .then(() => {
                    this.resetInputs();
                })
                .catch(error => {
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors);
                    }
                })
                .finally(() => {
                    this.toggleLoading();
                });
        }
    };
    resetPassword = () => {
        const { userId, resetPasswordFunc, toggleActions } = this.props;
        const { userForm } = this.state;
        toggleActions(true);
        Toastr.confirm(
            Translator.translate(`generic.resident.actions.resetPassword.confirm.message`, userForm.firstname, userForm.lastname),
            Translator.translate(`generic.resident.actions.resetPassword.confirm.title`),
            {
                onYes: () => {
                    resetPasswordFunc(userId)
                        .then(() => {
                            Toastr.success(
                                Translator.translate(`generic.resident.actions.resetPassword.success`, userForm.firstname, userForm.lastname)
                            );
                        })
                        .catch(() => {
                            Toastr.error(Translator.translate(`generic.resident.actions.resetPassword.error`, userForm.firstname, userForm.lastname));
                        });
                },
                onNo: () => {
                    toggleActions(false);
                }
            }
        );
    };

    resendWelcomeUserEmail = () => {
        const { userId, resendWelcomeUserEmailFunc, toggleActions } = this.props;
        const { userForm } = this.state;
        toggleActions(true);
        Toastr.confirm(
            Translator.translate(`generic.resident.actions.resendWelcomeEmail.confirm.message`, userForm.firstname, userForm.lastname),
            Translator.translate(`generic.resident.actions.resendWelcomeEmail.confirm.title`),
            {
                onYes: () => {
                    resendWelcomeUserEmailFunc(userId)
                        .then(() => {
                            Toastr.success(
                                Translator.translate(`generic.resident.actions.resendWelcomeEmail.success`, userForm.firstname, userForm.lastname)
                            );
                        })
                        .catch(() => {
                            Toastr.error(
                                Translator.translate(`generic.resident.actions.resendWelcomeEmail.error`, userForm.firstname, userForm.lastname)
                            );
                        });
                },
                onNo: () => {
                    toggleActions(false);
                }
            }
        );
    };
    switchMaster = () => {
        const { userId, switchMasterFunc, toggleActions } = this.props;
        const { userForm } = this.state;
        toggleActions(true);
        this.setState({ masterLoading: true });
        Toastr.confirm(
            Translator.translate(`generic.resident.actions.switchMaster.confirm.message`, userForm.firstname, userForm.lastname),
            Translator.translate(`generic.resident.actions.switchMaster.confirm.title`),
            {
                onYes: () => {
                    switchMasterFunc(userId).finally(() => {
                        this.setState({ masterLoading: false });
                    });
                },
                onNo: () => {
                    toggleActions(false);
                    this.setState({ masterLoading: false });
                }
            }
        );
    };
    deleteUser = () => {
        const { user, userId, otherUsers, deleteUserFunc, toggleActions, deleteUserAndSwitchMasterFunc } = this.props;
        const { userForm } = this.state;
        const isMaster = !!user.get('isMaster');

        toggleActions(true);
        this.setState({ loading: true, openedMenu: false });
        if (isMaster && otherUsers.length !== 0) {
            Toastr.select(
                Translator.translate(`generic.resident.actions.delete.confirm.masterMessage`, userForm.firstname, userForm.lastname),
                Translator.translate(`generic.resident.actions.delete.confirm.masterTitle`),
                otherUsers,
                {
                    onYes: masterId => {
                        deleteUserAndSwitchMasterFunc(userId, parseInt(masterId)).catch(() => {
                            this.setState({ loading: false });
                        });
                    },
                    onNo: () => {
                        toggleActions(false);
                        this.setState({ loading: false });
                    }
                }
            );
        } else {
            Toastr.confirm(
                Translator.translate(
                    isMaster ? `generic.resident.actions.delete.confirm.masterMessageAlone` : `generic.resident.actions.delete.confirm.message`,
                    userForm.firstname,
                    userForm.lastname
                ),
                Translator.translate(`generic.resident.actions.delete.confirm.title`),
                {
                    onYes: () => {
                        deleteUserFunc(userId).catch(() => {
                            this.setState({ loading: false });
                        });
                    },
                    onNo: () => {
                        toggleActions(false);
                        this.setState({ loading: false });
                    }
                }
            );
        }
    };
    validateForm(form) {
        const { specialUser } = this.state;
        const errors = {};
        const regexTel = RegExp(/^(\+[1-9]{2}\s|0)([1-9])((\s|\.|-)?\d{2}){4}$/);

        if (this.isEmpty(form.firstname)) {
            errors['firstname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.lastname)) {
            errors['lastname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (specialUser) {
            if (this.isEmpty(form.email)) {
                errors['email'] = Translator.translate('general.fields.error.any.empty');
            }
            if (this.isEmpty(form.password)) {
                errors['password'] = Translator.translate('general.fields.error.any.empty');
            }
        } else {
            if (this.isEmpty(form.email)) {
                errors['email'] = Translator.translate('general.fields.error.any.empty');
            } else if (!/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(form.email)) {
                errors['email'] = Translator.translate('general.fields.error.string.regex.base');
            }
            if (!this.isEmpty(form.telPort) && !regexTel.test(form.telPort)) {
                errors['telPort'] = Translator.translate('general.fields.error.string.regex.base');
            }
            if (!this.isEmpty(form.telFixe) && !regexTel.test(form.telFixe)) {
                errors['telFixe'] = Translator.translate('general.fields.error.string.regex.base');
            }
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    }

    /* RENDERS */
    renderSaveIcon() {
        const { classes } = this.props;
        const { specialUser } = this.state;

        return (
            <Fragment>
                <Tooltip title={Translator.translate('general.cancel')} placement="top">
                    <IconButton aria-label="Cancel" onClick={this.resetInputs}>
                        <CloseIcon className={classes.iconSize} />
                    </IconButton>
                </Tooltip>
                <Tooltip title={Translator.translate('general.save')} placement="top">
                    <IconButton aria-label="Save" onClick={specialUser ? this.saveSpecialUser : this.saveUser}>
                        <CheckIcon className={`${classes.iconSize} ${classes.masterColor}`} />
                    </IconButton>
                </Tooltip>
            </Fragment>
        );
    }
    renderMasterIcon() {
        const { user, actionDisabled, switchMasterRight, classes } = this.props;
        const { masterLoading } = this.state;
        const isMaster = !!user.get('isMaster');

        const Icon = isMaster ? StarIcon : StarBorderIcon;
        return (
            <Tooltip
                title={Translator.translate(`generic.resident.actions.switchMaster.title`)}
                placement="top"
                disableHoverListener={isMaster}
                disableTouchListener={isMaster}
                disableFocusListener={isMaster}
            >
                <span>
                    <IconButton
                        disabled={isMaster || actionDisabled}
                        hidden={!switchMasterRight}
                        aria-label="ChangeMaster"
                        onClick={this.switchMaster}
                    >
                        {!masterLoading ? (
                            <Icon className={`${classes.iconSize} ${actionDisabled ? null : classes.masterColor}`} />
                        ) : (
                            <CircularProgress size={25} color="inherit" />
                        )}
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
    renderCardContent() {
        const { classes } = this.props;
        const { userForm } = this.state;

        return (
            <Fragment>
                <Typography color="textSecondary" className={classes.contactText}>
                    {userForm.email}
                </Typography>

                <Typography color="textSecondary" className={classes.contactText}>
                    {userForm.telFixe}
                </Typography>

                <Typography color="textSecondary" className={classes.contactText}>
                    {userForm.telPort}
                </Typography>
            </Fragment>
        );
    }
    renderEditingCardContent() {
        const { userForm, specialUser, textInput_error } = this.state;

        if (specialUser) {
            return (
                <Grid container spacing={2}>
                    <Grid container item sm={12} md={6}>
                        <FHETextField
                            id="lastname"
                            value={userForm.lastname}
                            error={textInput_error.lastname}
                            fullWidth
                            label={Translator.translate('general.table.column.lastname')}
                            name="lastname"
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6}>
                        <FHETextField
                            id="firstname"
                            value={userForm.firstname}
                            error={textInput_error.firstname}
                            fullWidth
                            label={Translator.translate('general.table.column.firstname')}
                            name="firstname"
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid container item sm={12}>
                        <FHETextField
                            id="email"
                            value={userForm.email}
                            error={textInput_error.email}
                            fullWidth
                            label={Translator.translate('general.table.column.email')}
                            name="email"
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid container item sm={12}>
                        <FHETextField
                            id="password"
                            value={userForm.password}
                            error={textInput_error.password}
                            fullWidth
                            label={Translator.translate('general.table.column.password')}
                            name="password"
                            onChange={this.handleChange}
                        />
                    </Grid>
                </Grid>
            );
        }
        return (
            <Grid container spacing={2}>
                <Grid container item sm={12} md={6}>
                    <FHETextField
                        id="lastname"
                        value={userForm.lastname}
                        error={textInput_error.lastname}
                        fullWidth
                        label={Translator.translate('general.table.column.lastname')}
                        name="lastname"
                        onChange={this.handleChange}
                    />
                </Grid>
                <Grid container item sm={12} md={6}>
                    <FHETextField
                        id="firstname"
                        value={userForm.firstname}
                        error={textInput_error.firstname}
                        fullWidth
                        label={Translator.translate('general.table.column.firstname')}
                        name="firstname"
                        onChange={this.handleChange}
                    />
                </Grid>
                <Grid container item sm={12}>
                    <FHETextField
                        id="email"
                        value={userForm.email}
                        error={textInput_error.email}
                        fullWidth
                        label={Translator.translate('general.table.column.email')}
                        name="email"
                        onChange={this.handleChange}
                    />
                </Grid>
                <Grid container item sm={12} md={6}>
                    <FHETextField
                        id="telFixe"
                        value={userForm.telFixe}
                        error={textInput_error.telFixe}
                        fullWidth
                        label={Translator.translate('general.table.column.telFixe')}
                        name="telFixe"
                        onChange={this.handleChange}
                    />
                </Grid>
                <Grid container item sm={12} md={6}>
                    <FHETextField
                        id="telPort"
                        value={userForm.telPort}
                        error={textInput_error.telPort}
                        fullWidth
                        label={Translator.translate('general.table.column.telPort')}
                        name="telPort"
                        onChange={this.handleChange}
                    />
                </Grid>
            </Grid>
        );
    }
    renderCardActions() {
        const {
            user,
            otherUsers,
            modeAdd,
            actionDisabled,
            resetUserPasswordRight,
            resendWelcomeUserEmailRight,
            deleteMasterRight,
            switchMasterRight,
            deleteUserRight,
            editUserRight,
            classes
        } = this.props;
        const { editing, openedMenu, anchorEl } = this.state;

        const isMaster = !modeAdd && !!user.get('isMaster');
        let menuItems = [];
        if (editUserRight) {
            menuItems.push(
                <MenuItem key="edit" onClick={this.toggleEditingState}>
                    {Translator.translate('general.edit')}
                </MenuItem>
            );
        }
        if (
            (isMaster && ((otherUsers.length === 0 && deleteMasterRight) || (otherUsers.length > 0 && switchMasterRight && deleteUserRight))) ||
            (!isMaster && deleteUserRight)
        ) {
            menuItems.push(
                <MenuItem key="remove" onClick={this.deleteUser}>
                    {isMaster && otherUsers.length === 0
                        ? Translator.translate(`generic.resident.actions.delete.masterTitle`)
                        : Translator.translate(`generic.resident.actions.delete.title`)}
                </MenuItem>
            );
        }
        if (resetUserPasswordRight) {
            menuItems.push(
                <MenuItem key="resetPassword" onClick={this.resetPassword}>
                    {Translator.translate(`generic.resident.actions.resetPassword.title`)}
                </MenuItem>
            );
        }
        if (resendWelcomeUserEmailRight) {
            menuItems.push(
                <MenuItem key="resendWelcomeUserEmail" onClick={this.resendWelcomeUserEmail}>
                    {Translator.translate(`generic.resident.actions.resendWelcomeEmail.title`)}
                </MenuItem>
            );
        }

        if (editing) return <div className={`d-flex ${classes.header}`}>{this.renderSaveIcon()}</div>;

        return (
            <div className={`d-flex ${classes.header}`}>
                {this.renderMasterIcon()}
                {menuItems.length > 0 && (
                    <Fragment>
                        <IconButton
                            aria-label="More"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            disabled={actionDisabled}
                            onClick={this.openMenuState}
                        >
                            <MoreVertIcon className={classes.iconSize} />
                        </IconButton>
                        <Menu id="long-menu" anchorEl={anchorEl} keepMounted open={openedMenu} onClose={this.closeMenuState}>
                            {menuItems}
                        </Menu>
                    </Fragment>
                )}
            </div>
        );
    }
    render() {
        const { user, classes, modeAdd, profile, history } = this.props;
        const { editing, userForm, loading } = this.state;
        const creatSpecialUserRights =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`homeAddSpecialUser_${history.environment}`);
        const createUserRights = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeAddUser');
        if (loading) {
            return (
                <Card className={`${classes.homeUserCardContainer} align-self-center align-items-center justify-content-center d-flex`}>
                    <CardContent className={classes.cardContent}>
                        <div className={classes.loadingContainer}>
                            <CircularProgress />
                        </div>
                    </CardContent>
                </Card>
            );
        }

        if (modeAdd && !editing) {
            return (
                <Card className={`${classes.homeUserCardContainer} align-self-center align-items-center justify-content-center d-flex`}>
                    <div>
                        {creatSpecialUserRights && (
                            <Tooltip title={Translator.translate('general.homeAddSpecialUser')} placement="top">
                                <IconButton aria-label="AddSpecialUser" onClick={this.toggleEditingStateSpecialUser}>
                                    <PersonAddIcon className={`${classes.addIconSize} ${classes.specialUser}`} />
                                </IconButton>
                            </Tooltip>
                        )}
                        {createUserRights && (
                            <Tooltip title={Translator.translate('general.addHomeUser')} placement="top">
                                <IconButton aria-label="AddUser" onClick={this.toggleEditingState}>
                                    <PersonAddIcon className={`${classes.addIconSize} ${classes.masterColor}`} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>
                </Card>
            );
        }
        const isMaster = !modeAdd && !!user.get('isMaster');

        return (
            <Card className={`${classes.homeUserCardContainer} ${isMaster ? classes.masterBackgroundColorLight : ''}`}>
                <CardHeader
                    title={!editing && `${userForm.lastname} ${userForm.firstname}`}
                    className={`${classes.cardHeader} ${classes.masterColor}`}
                    action={this.renderCardActions()}
                    classes={{ title: classes.headerTitle }}
                />
                <CardContent className={classes.cardContent}>
                    <Fragment>{editing ? this.renderEditingCardContent() : this.renderCardContent()}</Fragment>
                </CardContent>
            </Card>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state)
    };
}
const styles = theme => ({
    headerTitle: {
        marginBottom: 10
    },
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    header: {
        height: 50
    },
    iconSize: {
        fontSize: 25
    },
    addIconSize: {
        fontSize: 40
    },
    specialUser: {
        color: theme.palette.warning.main
    },
    masterColor: {
        color: theme.palette.primary.main
    },
    masterBackgroundColorLight: {
        border: `solid 1px ${theme.palette.primary.main}`
    },

    homeUserCardContainer: {
        width: '100%',
        marginTop: 10,
        marginBottom: 10,
        minHeight: 150
    },

    cardHeader: {
        padding: '15px 15px 0px 15px'
    },

    cardContent: {
        padding: '0px 15px 15px 15px'
    },
    nameText: {
        overflowWrap: 'break-word',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.3em'
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.1em'
        }
    },
    contactText: {
        overflowWrap: 'break-word',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.9em'
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.8em'
        }
    }
});

export default withRouter(
    renderEnvComponent('scenes/Home/components/UserCard', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(UserCard)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/UserCard.js